/* eslint-disable max-len */
import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Floppy = (props: Props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3553_13432)">
      <path
        d="M5.50468 1.64999H5.1929C4.25324 1.64999 3.35206 2.02327 2.68762 2.68771C2.02318 3.35215 1.6499 4.25333 1.6499 5.19299V15.1407C1.6499 15.9926 1.98831 16.8096 2.59067 17.4119C3.19303 18.0143 4.01001 18.3527 4.86188 18.3527M5.50468 1.64999V4.12199C5.50468 4.65894 5.71798 5.1739 6.09766 5.55358C6.47734 5.93326 6.9923 6.14656 7.52925 6.14656H9.90407C10.441 6.14656 10.956 5.93326 11.3357 5.55358C11.7153 5.1739 11.9286 4.65894 11.9286 4.12199V1.64999M5.50468 1.64999H11.9286M4.86188 18.3527V13.0382C4.86188 12.2328 5.18183 11.4603 5.75135 10.8908C6.32087 10.3213 7.09331 10.0013 7.89873 10.0013H12.1038C12.9092 10.0013 13.6816 10.3213 14.2511 10.8908C14.8207 11.4603 15.1406 12.2328 15.1406 13.0382V18.3527M4.86188 18.3527H15.1406M11.9286 1.64999H11.955C12.3539 1.64995 12.7489 1.7285 13.1175 1.88118C13.4861 2.03385 13.821 2.25765 14.103 2.53979L17.315 5.75177C17.644 6.08079 17.9049 6.47139 18.083 6.90127C18.261 7.33115 18.3526 7.79189 18.3526 8.25717V15.1407C18.3526 15.9926 18.0142 16.8096 17.4118 17.4119C16.8095 18.0143 15.9925 18.3527 15.1406 18.3527"
        stroke={props.color ?? props?.style?.color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3553_13432">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Floppy;
